import repository from '@/utils/repository';

// const resource = '/move/cus_system/MNG_System004';
const resource = '/move/m903';

export default {
    storeSupplier: (data) => {
        return repository.post(`${resource}`, {
            ...data
        });
    },
    searchItem: (data) => {
        return repository.post(`${resource}/search`, {
            ...data
        });
    }
};
